import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    flex: 1,
  },
  sectionTitle: {
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "20px",
    color: "#344054",
    margin: 0,
  },
  dropzone: {
    border: "2px dashed #D0D5DD",
    borderRadius: "8px",
    padding: "32px 24px",
    backgroundColor: "#FCFCFD",
    cursor: "pointer",
    transition: "all 0.2s ease",
    "&:hover": {
      borderColor: "#0055A4",
      backgroundColor: "#F9FAFB",
    },
  },
  dropzoneActive: {
    borderColor: "#0055A4",
    backgroundColor: "#E6EEF6",
  },
  dropzoneDisabled: {
    cursor: "not-allowed",
    opacity: 0.6,
    "&:hover": {
      borderColor: "#D0D5DD",
      backgroundColor: "#FCFCFD",
    },
  },
  dropzoneContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
  },
  uploadIcon: {
    color: "#0055A4",
    marginBottom: "8px",
  },
  uploadText: {
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "20px",
    color: "#344054",
    margin: 0,
  },
  uploadSubtext: {
    fontFamily: "Manrope",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "16px",
    color: "#667085",
    margin: 0,
  },
  uploadInfo: {
    fontFamily: "Manrope",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "16px",
    color: "#667085",
    marginTop: "8px",
    textAlign: "center",
  },
  formatText: {
    fontWeight: 600,
    color: "#344054",
  },
  attachmentsList: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  attachmentChip: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px 12px",
    backgroundColor: "#F9FAFB",
    borderRadius: "999px",
    border: "1px solid #E4E7EC",
  },
  attachmentChipLeft: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flex: 1,
    minWidth: 0,
  },
  fileIcon: {
    color: "#667085",
    flexShrink: 0,
  },
  attachmentChipText: {
    fontFamily: "Manrope",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "16px",
    color: "#344054",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  attachmentChipRemove: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    color: "#667085",
    marginLeft: "8px",
    flexShrink: 0,
    "&:hover": {
      color: "#F97066",
    },
  },
}));

export default useStyles;

